module.exports = __webpack_public_path__ + "assets/img/PingPong_logo.3b03c2d5.svg";